const isMacOs = () => /Mac/i.test(window?.navigator?.platform);
export const getShortcutModifierKey = () => (isMacOs() ? 'meta' : 'ctrl');
